/* eslint-disable react/prop-types */
import OnlyBackendComponent from "./only-backend";

function OnlyBackend({ announcement, updateAnnouncement }) {
  const handleInternalNotesChange = (e) => {
    updateAnnouncement("internalNotes", e.target.value, announcement);
  };

  const handleFollowedCompaniesChange = (e) => {
    updateAnnouncement("followedCompanies", e.target.value, announcement);
  };

  const handleReportingPriceChange = (e) => {
    updateAnnouncement("reportingPrice", e.target.value, announcement);
  };

  const handleQuestionPriceChange = (e) => {
    updateAnnouncement("questionPrice", e.target.value, announcement);
  };

  const handleYearChange = (e) => {
    updateAnnouncement("year", parseInt(e.target.value), announcement);
  };

  return (
    <OnlyBackendComponent
      onInternalNotesChange={handleInternalNotesChange}
      onFollowedCompaniesChange={handleFollowedCompaniesChange}
      onReportingPriceChange={handleReportingPriceChange}
      onQuestionPriceChange={handleQuestionPriceChange}
      onYearChange={handleYearChange}
      announcement={announcement}
    />
  );
}

export default OnlyBackend;
